import { render, staticRenderFns } from "./DictionaryEditModal.vue?vue&type=template&id=597c4442&"
import script from "./DictionaryEditModal.vue?vue&type=script&lang=js&"
export * from "./DictionaryEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports